<template>
    <Page class="solutions">
        <h1>Open Source Observability Solutions</h1>

        <p>
            At Coroot, we possess considerable expertise in deploying Observability solutions across companies of different scales,
            comprehending the varied demands you may have.
            While we believe that the Coroot Observability Platform can greatly improve your Observability strategy,
            we know it might not cover everything you require.
        </p>

        <p>
            However, the Open Source Observability arena offers extensive options, and the Coroot team is adept in leading solutions
            like OpenTelemetry, Prometheus, Grafana, ClickHouse, VictoriaMetrics, and Jaeger, among others.
            We stand ready to support your organization in effectively fulfilling its Open Source Observability requirements.
        </p>

        <v-row class="my-10 text-center text-h5">
            <v-col v-for="(name, id) in logos">
                <img class="ma-auto d-block" height="100px" :src="`/static/img/logos/${id}.png`" :alt="id" />
                <div>{{name}}</div>
            </v-col>
        </v-row>

        <p>Here are some ways we can help implement cutting-edge Open Source Observability for your business:</p>
        <ul>
            <li>Open Source Observability Strategy</li>
            <li>Migration to Open Source Observability Solutions</li>
            <li>Dashboards and Alerting Design and Implementation</li>
            <li>Service Level Objectives (SLOs)</li>
            <li>Incident Management</li>
            <li>Operational Best Practices: High Availability, Security, Performance</li>
        </ul>

        <p>
            Start with a free 1-hour observability strategy discussion with Coroot experts
            to explore how we can improve your observability and lower costs.
        </p>
        <div class="text-center mt-7">
            <ContactUs btn-class="filled-blue text-no-wrap text-center" />
        </div>

    </Page>
</template>

<script>
import Page from "@/pages/Page";
import ContactUs from "@/pages/ContactUs.vue";

export default {
    components: {ContactUs, Page},
    computed: {
        logos() {
            return {
                prometheus: 'Prometheus',
                grafana: 'Grafana',
                victoriametrics: 'VictoriaMetrics',
                clickhouse: 'ClickHouse',
                opentelemetry: 'OpenTelemetry',
                jaeger: 'Jaeger',
            }
        },
    },
}
</script>

<style scoped>
.solutions {
    font-family: Poppins, sans-serif;
}
</style>
